import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateBancoForm } from '../Validations/ValidationsBanco';

export default function EditBancoForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    codigo: '',
    documentoTercero: '',
    descripcion: '',
    nombreBanco: '',
    iban: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBanco = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`/bancos/${id}`);
        setFormData(response.data);
      } catch (err) {
        setError('Error al cargar los datos del banco.');
        console.error('Error fetching banco:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBanco();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    setErrors(prevErrors => ({
      ...prevErrors,
      [name]: ''
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = await validateBancoForm(formData);
    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      setError(null);
      try {
        await axios.put(`/bancos/${id}`, formData);
        navigate('/home/bancos');
      } catch (err) {
        setError('Error al actualizar el banco. Por favor, intente de nuevo.');
        console.error('Error updating banco:', err);
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  if (isLoading) return <div className="text-center mt-8">Cargando...</div>;
  if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

  return (
    <div className="max-w-2xl mx-auto mt-8">
      <h2 className="text-2xl font-bold mb-4">Editar Banco</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1">Código</label>
          <input
            type="text"
            name="codigo"
            value={formData.codigo}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
            readOnly
          />
        </div>
        <div>
          <label className="block mb-1">Documento del Tercero</label>
          <input
            type="text"
            name="documentoTercero"
            value={formData.documentoTercero}
            onChange={handleChange}
            className={`w-full p-2 border rounded ${errors.documentoTercero ? 'border-red-500' : ''}`}
            required
          />
          {errors.documentoTercero && <p className="text-red-500 text-xs italic">{errors.documentoTercero}</p>}
        </div>
        <div>
          <label className="block mb-1">Descripción</label>
          <input
            type="text"
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            className={`w-full p-2 border rounded ${errors.descripcion ? 'border-red-500' : ''}`}
          />
          {errors.descripcion && <p className="text-red-500 text-xs italic">{errors.descripcion}</p>}
        </div>
        <div>
          <label className="block mb-1">Nombre del Banco</label>
          <input
            type="text"
            name="nombreBanco"
            value={formData.nombreBanco}
            onChange={handleChange}
            className={`w-full p-2 border rounded ${errors.nombreBanco ? 'border-red-500' : ''}`}
            required
          />
          {errors.nombreBanco && <p className="text-red-500 text-xs italic">{errors.nombreBanco}</p>}
        </div>
        <div>
          <label className="block mb-1">IBAN</label>
          <input
            type="text"
            name="iban"
            value={formData.iban}
            onChange={handleChange}
            className={`w-full p-2 border rounded ${errors.iban ? 'border-red-500' : ''}`}
            required
          />
          {errors.iban && <p className="text-red-500 text-xs italic">{errors.iban}</p>}
        </div>
        <button
          type="submit"
          className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
          disabled={isLoading}
        >
          {isLoading ? 'Actualizando...' : 'Actualizar Banco'}
        </button>
      </form>
    </div>
  );
}